import PrimaryBtn from "../UI/PrimaryBtn";
import styles from "./Info.module.css";
import infoImg from "../../assets/images/info-bg.png";

const Info = () => {
  return (
    <section className={styles.section}>
      <img className={styles.img} src={infoImg} alt="Football Ground" />
      <div className={styles.container}>
        <h2 className={styles.heading}>play on the best turf</h2>
        <div className={styles.contentContainer}>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
        </div>
        <PrimaryBtn className={styles.btn}>Know More</PrimaryBtn>
      </div>
    </section>
  );
};

export default Info;
